import HttpUtil from "@/utils/HttpUtil";

/**
 * 文档模板服务
 */
export default {
    //获取文档模板列表
    getPageList(pageNum,pageSize,kw){
        return new Promise((resolve,reject)=>{
            HttpUtil.postJson("/data-center-provider/docTpl/pageList",{kw,pageNum,pageSize}).then((re)=>{
                if (re.code === "ok"){
                    resolve(re.body);
                }else{
                    reject(re.msg);
                }
            }).catch((e)=>{
                console.log("获取文档模板异常",e)
                reject(e);
            })
        });
    },
    //创建文档模板
    createDocTpl(params){
        return new Promise((resolve,reject)=>{
            HttpUtil.postJson("/data-center-provider/docTpl/create",params).then((re)=>{
                if (re.code === "ok"){
                    resolve(re.body);
                }else{
                    reject(re.msg);
                }
            }).catch((e)=>{
                console.log("创建文档模板异常",e)
                reject(e);
            })
        });
    },
    //修改文档模板
    updateDocTpl(id,params){
        return new Promise((resolve,reject)=>{
            HttpUtil.postJson("/data-center-provider/docTpl/update/"+id,params).then((re)=>{
                if (re.code === "ok"){
                    resolve(re.body);
                }else{
                    reject(re.msg);
                }
            }).catch((e)=>{
                console.log("修改文档模板异常",e)
                reject(e);
            })
        });
    },
    //文档模板切换启用状态
    switchDocTplEnable(id,enable){
        return new Promise((resolve,reject)=>{
            HttpUtil.post("/data-center-provider/docTpl/switchEnable/"+id,{
                enable
            }).then((re)=>{
                if (re.code === "ok"){
                    resolve(re.body);
                }else{
                    reject(re.msg);
                }
            }).catch((e)=>{
                console.log("更新文档模板异常",e);
                reject(e);
            })
        });
    },
    //删除文档模板
    deleteDocTpl(id){
        return new Promise((resolve,reject)=>{
            HttpUtil.post("/data-center-provider/docTpl/delete/"+id,{}).then((re)=>{
                if (re.code === "ok"){
                    resolve(re.body);
                }else{
                    reject(re.msg);
                }
            }).catch((e)=>{
                console.log("删除文档模板异常",e);
                reject(e);
            })
        });
    },
    /**
     * 上传文档模板
     * @param data
     * @returns {Promise<unknown>}
     */
    uploadFiles(data){
        const formData = new FormData()
        formData.append('file', data.file)
        formData.append('name', '')
        return new Promise((resolve,reject)=>{
            HttpUtil.postFormData("/storage-provider/storage/putFile",formData,null).then((re)=>{
                if (re.code === "ok"){
                    resolve(re.body);
                }else{
                    reject(re.msg);
                }
            }).catch((e)=>{
                console.log("上传文档模板异常",e)
                reject(e);
            })
        });
    }
}
